import React, { useState } from "react";
import { FixaListView } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListView";
import { FixaListViewItem } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListViewItem";
import MagnifyingGlassIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/MagnifyingGlassIconPath";
import { useToastNotification } from "@coworker/components/src/components/ToastNotification";
import { useTranslation } from "@coworker/locales";
import { ReplacedArticleListItem } from "../Molecules/ReplacedArticleListItem";
import { Item } from "@coworker/apprestructured/src/shared/types/item";
import ScannerSearchComboComponent from "@coworker/apprestructured/src/scan-and-search/components/scanner-search-combo-component/ScannerSearchComboComponent";
import { FullScreenSearchContainer } from "@coworker/app/src/components/TestBuy/NewTestBuy/CustomArticleWidget";

interface ReplaceProductProps {
  oldProductArticleIds: string[];
  numberBackup: number;
  alternativeBackupItemNo?: string;
  isSetAsBackupProduct?: boolean;
  alternativeBackUpProduct?: Item | undefined;
  handleItemChange?: (itemNo: string) => void;
}

export const ReplaceProduct = ({
  oldProductArticleIds,
  numberBackup,
  alternativeBackupItemNo,
  isSetAsBackupProduct = false,
  handleItemChange,
}: ReplaceProductProps) => {
  const { t } = useTranslation();
  const { showToast } = useToastNotification();

  const [shouldOpenSearchScreen, setShouldOpenSearchScreen] = useState(false);
  const [backupItemNo, setIsBackupItemNo] = useState(alternativeBackupItemNo);
  const handleItemSelection = async (productNo: string) => {
    setShouldOpenSearchScreen(false);
    if (productNo) {
      if (oldProductArticleIds.includes(productNo)) {
        showToast(
          t("productAlreadyExistInRoomString"),
          undefined,
          undefined,
          5
        );
        setShouldOpenSearchScreen(false);
        return;
      }
      setIsBackupItemNo(productNo);
      handleItemChange?.(productNo);
    }
  };

  const title = isSetAsBackupProduct
    ? "setBackupArticleString"
    : "newProductString";
  return (
    <>
      <div onClick={() => setShouldOpenSearchScreen(true)}>
        <FixaListView id="replace-product-list" size={"small"}>
          <FixaListViewItem
            title={t(title)}
            leadingIcon={MagnifyingGlassIconPath}
            control={"navigational"}
            controlIcon={"chevronRightSmall"}
            emphasised
            inset
          />
        </FixaListView>
        {backupItemNo && (
          <ReplacedArticleListItem
            numberBackup={numberBackup}
            itemNo={backupItemNo || ""}
            isSetAsBackupProduct={isSetAsBackupProduct}
          />
        )}
      </div>
      {shouldOpenSearchScreen && (
        <FullScreenSearchContainer>
          <ScannerSearchComboComponent
            handleProductSearchResult={handleItemSelection}
            handleCloseOfComponent={() => setShouldOpenSearchScreen(false)}
            shouldHideLocalCombinationItems={false}
          />
        </FullScreenSearchContainer>
      )}
    </>
  );
};
